import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2, ArrowLeft, Instagram, Linkedin } from 'lucide-react';

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentLang = location.pathname.includes('/danke') ? 'de' : 'en';

  useEffect(() => {
    document.title = currentLang === 'en' 
      ? 'Thank You | Podcast Zürich' 
      : 'Danke | Podcast Zürich';
  }, [currentLang]);

  const content = {
    en: {
      title: 'Thank You!',
      subtitle: 'Your message has been received',
      message: 'We appreciate you reaching out to us. Our team will review your message and get back to you very soon.',
      backButton: 'Back to Website',
      followUs: 'Follow us on social media',
    },
    de: {
      title: 'Danke!',
      subtitle: 'Ihre Nachricht wurde empfangen',
      message: 'Wir freuen uns über Ihre Kontaktaufnahme. Unser Team wird Ihre Nachricht prüfen und sich sehr bald bei Ihnen melden.',
      backButton: 'Zurück zur Website',
      followUs: 'Folgen Sie uns auf Social Media',
    },
  };

  const t = content[currentLang];

  return (
    <div className="min-h-screen pt-24 pb-16 flex items-center justify-center">
      <div className="max-w-xl mx-auto px-6 text-center">
        {/* Success Icon */}
        <div className="mb-8 flex justify-center">
          <div 
            className="w-24 h-24 rounded-full flex items-center justify-center"
            style={{ backgroundColor: '#ffff31' }}
          >
            <CheckCircle2 className="w-12 h-12 text-black" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-6xl font-bold mb-4 text-gray-900">
          {t.title}
        </h1>
        
        {/* Subtitle */}
        <p className="text-xl text-gray-600 mb-6">
          {t.subtitle}
        </p>

        {/* Message */}
        <p className="text-lg text-gray-700 mb-10 leading-relaxed">
          {t.message}
        </p>

        {/* Back Button */}
        <Button
          size="lg"
          style={{ backgroundColor: '#ffff31', color: '#000' }}
          className="font-semibold hover:opacity-90 text-lg px-10 mb-12"
          onClick={() => navigate(currentLang === 'en' ? '/en' : '/de')}
        >
          <ArrowLeft className="mr-2 w-5 h-5" />
          {t.backButton}
        </Button>

        {/* Social Media */}
        <div>
          <p className="text-gray-500 mb-4">{t.followUs}</p>
          <div className="flex justify-center gap-4">
            <a
              href="https://www.instagram.com/podcast_zurich/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors"
            >
              <Instagram className="w-6 h-6 text-gray-700" />
            </a>
            <a
              href="https://www.linkedin.com/company/podcast-zurich/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors"
            >
              <Linkedin className="w-6 h-6 text-gray-700" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
